import React from 'react';
import PropTypes from 'prop-types';
import Navigateleft from '@nerdwallet/react-icon/gizmo/Navigateleft';

var BackButton = function BackButton(_ref) {
  var history = _ref.history;

  function navigateBack(e) {
    e.preventDefault();
    var fallback = '/credit-cards'; // If there is no browser history, send them to the portal

    if (window.history.length <= 1) {
      window.location.pathname = fallback;
    } else {
      history.goBack();
    }

    return false;
  }

  return React.createElement("a", {
    href: "/rewards-credit-cards",
    className: "back",
    onClick: navigateBack
  }, React.createElement(Navigateleft, {
    className: "icon navigateleft"
  }), React.createElement("span", null, "Back"));
};

BackButton.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func // eslint-disable-line react/no-unused-prop-types

  })
};
export default BackButton;
//# sourceMappingURL=compare-back-button.js.map